import { Helmet } from 'react-helmet';
import ContactUsForm from "../components/ContactUs/ContactUsFormComponent";
import Address from "../components/ContactUs/AddressComponent";
import WhyChoose from "../components/Home/WhyChoose";
import GoogleMapComponent from '../components/GoogleMapComponent';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

export const metadata = {
  title: "Contact Us | Travel Experts | Halo Holidays",
  description: "Have questions about your booking or need help planning your trip? Contact our friendly travel experts at Halo Holidays.",
};

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{metadata.title}</title>
          <meta name="description" content={metadata.description} />
        </Helmet>
      </HelmetProvider>
      <div className="container mx-auto p-4">
        <div className="map-outer mt-4">
          <div className="map-canvas w-full bg-gray-100 rounded-lg shadow-lg">
            <GoogleMapComponent
              apiKey="AIzaSyA9BsQCRVPXir7IlI-B9_W1-47Z3lA4Udw"
              latitude={parseFloat('55.02261')}
              longitude={parseFloat('-1.51299')}
              zoom={14}
            />
          </div>
        </div>

        <section className="relative contact-form">
          <div className="row_ justify-end">
            <div className="col-xl-5 col-lg-7">
              <div className="map-form bg-white rounded-lg shadow-4 cnt-pdng">
                <ContactUsForm />
              </div>
            </div>
          </div>
        </section>

        <section className="max-h-640 md:min-h-0 lg:min-h-0 my-8">
          <hr className="mb-10" />
          <Address />
        </section>

        <section className="max-h-640 md:min-h-0 lg:min-h-0">
          <hr className="mb-10" />
          <h2 className="text-3xl font-semibold items-center justify-center flex mt-10">More reasons to choose us</h2>
          <WhyChoose />
        </section>

      </div>
    </>
  );
};

export default ContactUs;